import React from 'react';
import styled from 'styled-components';
import { CrudStyles } from './Crud';

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    box-sizing: border-box;
    padding: 16px;
    overflow-y: auto;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
`;

const ModalBox = styled.div`
    box-sizing: border-box;
    background: white;
    padding: 24px;
    border-radius: 12px;
    width: 100%;
    max-width: min(440px, calc(100vw - 32px));
    max-height: min(90vh, 90dvh);
    overflow-y: auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

const Title = styled.h2`
    margin: 0 0 12px;
    font-size: 18px;
    color: ${({ theme }) => theme?.colors?.gray?.[900] || '#222'};
`;

const Message = styled.div`
    margin: 0 0 24px;
    font-size: 14px;
    line-height: 1.5;
    color: ${({ theme }) => theme?.colors?.gray?.[900] || '#444'};
    white-space: pre-line;
`;

const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 8px;
`;

const { Button } = CrudStyles;

/**
 * Modal de confirmação (Cancelar / Confirmar).
 */
export default function ConfirmModal({
    open,
    title = 'Confirmar',
    message,
    confirmLabel = 'Confirmar',
    cancelLabel = 'Cancelar',
    confirmVariant = 'danger',
    onConfirm,
    onCancel,
}) {
    if (!open) return null;

    return (
        <Overlay role="dialog" aria-modal="true" onClick={(e) => e.target === e.currentTarget && onCancel?.()}>
            <ModalBox onClick={(e) => e.stopPropagation()}>
                <Title>{title}</Title>
                {message != null && <Message>{message}</Message>}
                <Actions>
                    <Button type="button" variant="outline" onClick={onCancel}>
                        {cancelLabel}
                    </Button>
                    <Button type="button" variant={confirmVariant} onClick={onConfirm}>
                        {confirmLabel}
                    </Button>
                </Actions>
            </ModalBox>
        </Overlay>
    );
}
